import { useModalContext } from '../contexts/ModalProvider';

function useModal() {
  const { createModal, removeModal } = useModalContext();
  return { createModal, removeModal };
}

export default useModal;